import styled from 'styled-components';

import { Header as ModalHeader } from '@common/components/BookingForms/Modal';
import { Button } from '../../../../../Button';

export const Header = styled(ModalHeader)`
  padding: 12px 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 20px 20px 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;

  & img {
    max-width: 100%;
    margin-top: 20px;
  }
`;

export const Name = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-family: ${({ theme }) => theme.headerFont};
  font-size: 22px;
  margin: 24px 0 8px 0;
  flex-grow: 0;
  line-height: 24px;
`;

export const ReturnButton = styled(Button)`
  width: 100%;
  margin: 10px;
  margin: auto 0 0 0;
  background-color: ${({ theme }) => theme.customColors.primary};
  color: white;
`;
